import { Theme } from '../components/PreviewPage/ThemeCard';
import { useWebsiteLayoutContext } from '../context/WebsiteLayoutContext';

const useBuildThemeAnalyticsBaseProps = () => {
  const { layout } = useWebsiteLayoutContext();

  const getThemeAnalyticsBaseProps = (activeTheme?: Theme | null) => {
    return {
      designName: activeTheme?.name || '',
      familyName: activeTheme?.family || activeTheme?.name,
      partnerName: activeTheme?.themeDesigner?.companyName || 'The Knot',
      paperTheme: !!activeTheme?.designerUrl,
      colorwayTheme: !!activeTheme?.swatchImage,
      page: 'preview',
      layout: layout || 'multi-page',
    };
  };

  return { getThemeAnalyticsBaseProps };
};

export default useBuildThemeAnalyticsBaseProps;
